/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_DeleteInputs */

const en_recipe_delete = /** @type {(inputs: Recipe_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete recipe`)
};

const de_recipe_delete = /** @type {(inputs: Recipe_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezept löschen`)
};

/**
* | output |
* | --- |
* | "Delete recipe" |
*
* @param {Recipe_DeleteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_delete = /** @type {((inputs?: Recipe_DeleteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_DeleteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_delete(inputs)
	return en_recipe_delete(inputs)
});